import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './UserContext'; // Import the UserProvider
import {
  useParams, useLocation, Navigate, 
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";

import NotificationsPage from './components/NotificationsPage'; // Import the NotificationsPage component
import UserProfile from './components/UserProfile';
import MainPage from './components/MainPage';
// import MobileCardMaker from './MobileCardMaker';
import Contest from './components/Contest';
import ContestList from './components/ContestList';
import ReportsMod from './components/ReportsMod';
import ModerationLog from './components/ModerationLog';
import SetTest from './components/Sets/SetTest';
import SetLibrary from './components/Sets/SetLibrary';
import CardCreator from './components/Creator/creator'
// import templateData from './minionTemplate.json'; // Adjust path

import NotFound from './components/NotFound';
import UserCardOrganizer from './components/UserCardOrganizer';
import SearchResultsPage from './components/SearchResultsPage';
// import GalleryStats from './components/GalleryStats';
// import SetDisplay from './components/SetDisplay';
import ContestManagement from './components/ContestManagement';
import ArtSaron from './components/Games/artsarron'; 
import PublicSetGallery from './components/SetGallery/PublicSetGallery';

const RedirectToGallery = ({ targetPattern }) => {
  const params = useParams();
  const { search } = useLocation(); // Keeps "?selectedCard=XXXX"
  let target = targetPattern;

  // Replace dynamic tokens like :userId with actual values
  Object.entries(params).forEach(([key, value]) => {
    target = target.replace(`:${key}`, value);
  });

  return <Navigate to={`${target}${search}`} replace />;
};

const router = createBrowserRouter([
  {
    path: "sets/:setId",
    element: <SetTest />,
  },
  {
    path: "/",
    element: <App />, // App acts as the global shell
    children: [
      {
        index: true, // Matches exactly "/" (served by CardCreator)
        element: <CardCreator />,
      },
      {
        path: "artsaron",
        element: <ArtSaron />,
      },
    {
    path: "sets",
    element: <SetLibrary />,
  },
      {
        path: "gallery",
        children: [
{
              path: "sets",
            element: <PublicSetGallery />,
          },
          {
            index: true, // Matches "/gallery"
            element: <MainPage />,
          },
          {
            path: "notifications",
            element: <NotificationsPage />,
          },
          {
            path: "search-results",
            element: <SearchResultsPage />,
          },
          {
            path: "mycards",
            element: <UserCardOrganizer />,
          },
          // {
          //   path: "statistics",
          //   element: <GalleryStats />,
          // },
          {
            path: "user/:userId",
            element: <UserProfile />,
            children: [
              {
                path: ":tab",
                element: <UserProfile />,
              },
            ]
          },
          {
            path: "contests/list",
            element: <ContestList />,
          },
          {
            path: "contests/admin",
            element: <ContestManagement />,
          },
          {
            path: "contests/:id",
            element: <Contest />,
          },
          {
            path: "reports",
            element: <ReportsMod />,
          },
          {
            path: "moderation",
            element: <ModerationLog />,
          },
        ]
      }
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

      <UserProvider>
      <RouterProvider router={router} />
	    </UserProvider>

);
